import { render, staticRenderFns } from "./VehBusiness.vue?vue&type=template&id=6be29c4d&"
import script from "./VehBusiness.vue?vue&type=script&lang=js&"
export * from "./VehBusiness.vue?vue&type=script&lang=js&"
import style0 from "./VehBusiness.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports